import axios from 'axios';
import store from '@/store';
import querystring from 'querystring';
import { getToken } from "@/util/auth";
import { MessageBox,Message } from 'element-ui';
import router from '@/router'

//四轮车接口地址

const instance = axios.create({
  timeout: 20000
});

const instanceApi =  axios.create({
    timeout: 20000,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
});

export let isRelogin = { show: false };
// 拦截请求
instance.interceptors.request.use(config => {
    config.headers['Content-Type'] =  'application/x-www-form-urlencodedl;charset=utf-8';
    const isToken = (config.headers || {}).isToken === false
    if(getToken() && !isToken){
        config.headers['Authorization']  = 'Bearer ' + getToken();
    }
    return config;
}, error=>{
    console.log(error);
    Promise.reject(error);
});

// 拦截响应
instance.interceptors.response.use(res => {
    if (res.config.customExport) {
        return res;
    }
    let response = res.data;
    if(response.succeed){
        return response;
    }else{
        const code = response.code;
        if(code === 567){
            if(!isRelogin.show){
                isRelogin.show = true;
                MessageBox.confirm('登录状态已经过期，请重新登录','系统提示',{
                    confirmButtonText: '重新登录',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(()=>{
                    isRelogin.show = false;
                    store.dispatch('LogOut').then(()=>{
                        router.push('/login')
                    })
                }).catch(()=>{
                    isRelogin.show = false;
                })
            }
        }else{
            Message({message: response.msg, type: 'error'})
            return Promise.reject(new Error(response.msg))
        }
    }
});


export function post (url, params) {
  return instanceApi.post(url, querystring.stringify(params));
}

export const exportExcel  = (url, params = {}) => {
    return instance({
        method: 'post',
        url,
        params: params,
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        customExport: true
    }).then(response => {
        const blob = response.data;
        const contentType = response.headers['content-type'];
        if (contentType && contentType.includes('application/json')) {
            return new Promise((_, reject) => {
                const reader = new FileReader();
                reader.readAsText(blob, 'utf-8');
                reader.onload = () => {
                    try {
                        const json = JSON.parse(reader.result);
                        Message.error(json.msg || '导出失败');
                        reject(new Error(json.msg || '导出失败'));
                    } catch (e) {
                        Message.error('导出失败：解析错误');
                        reject(e);
                    }
                };
            });
        }
        let fileName = '下载文件.xlsx';
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    }).catch(() => {
        Message.error('导出失败，请稍后重试');
    });
};

export default instance;